import { UpgradeSubscriptionModal } from '@components'

import { Button, ButtonsGroup, Color, Icon, Tooltip, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../enums/modalId'
import { Scope } from '../../../../enums/scope'
import { TrackingContext } from '../../../../enums/trackingContext'
import { isAuthorized } from '../../../../utils/isAuthorized'
import { useDashboardSettings } from '../../contexts/dashboardSettingsContext'
import { useWidgetsActions } from '../../hooks/useWidgetsActions'

export const DashboardWidgetsEditAction = (): ReactElement => {
  const { t } = useTranslation()
  const { resetWidgets } = useWidgetsActions()
  const { isEditMode, setIsEditMode } = useDashboardSettings()
  const { open: openUpgradeSubscriptionModal } = useModal(ModalId.UpgradeSubscriptionModal)

  const canEditDashboardWidgets = isAuthorized(Scope.DashboardWrite)

  const handleEditModeClick = useCallback(() => {
    if (canEditDashboardWidgets) {
      setIsEditMode(!isEditMode)
      return
    }

    openUpgradeSubscriptionModal()
  }, [canEditDashboardWidgets, isEditMode, openUpgradeSubscriptionModal, setIsEditMode])

  const handleResetClick = useCallback(() => {
    resetWidgets()
  }, [resetWidgets])

  return (
    <>
      <ButtonsGroup>
        <Tooltip label={t('customize.dashboard.tooltip')}>
          <Button
            active={isEditMode}
            data-testid="dashboard-widgets-edit-button"
            fullRound
            icon={<Icon icon="settings" size="sm" color={canEditDashboardWidgets ? 'currentColor' : Color.Grey400} />}
            onClick={handleEditModeClick}
            size="md"
            variant="text"
          />
        </Tooltip>
        {isEditMode && (
          <Button icon="refresh" onClick={handleResetClick} size="sm" variant="text">
            {t('dashboard.widget.actions.reset')}
          </Button>
        )}
      </ButtonsGroup>
      <UpgradeSubscriptionModal
        id={ModalId.UpgradeSubscriptionModal}
        trackingContext={TrackingContext.PaymentInformationEdit}
      />
    </>
  )
}
